export const heroSlides = [
  {
    id: "hero-1",
    episodeId: "ep-01",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20rainy%20old%20residential%20apartment%20alley%20in%20Korea%20at%20night%2C%20warm%20amber%20window%20lights%2C%20wet%20reflective%20pavement%2C%20deep%20dark%20shadows%2C%20moody%20atmospheric%20lighting%2C%20anamorphic%20look%2C%20no%20text&width=1600&height=900&seq=fm4-hero-01&orientation=landscape",
    eyebrow: "2026 · 都市情感剧集 · 全16集",
    title: "朋友的妈妈4",
    description:
      "一栋旧公寓、两户人家、二十年前的一段旧事。志勋搬进来的那个秋天，所有被藏起来的话开始慢慢浮上来。",
    tag: "本剧专题",
  },
  {
    id: "hero-2",
    episodeId: "ep-09",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20a%20sunlit%20dusty%20art%20studio%20with%20wooden%20easel%2C%20paint%20brushes%20and%20old%20frames%2C%20golden%20amber%20light%20streaming%20through%20tall%20window%2C%20warm%20dark%20interior%2C%20hopeful%20quiet%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=fm4-hero-02&orientation=landscape",
    eyebrow: "第9集 · 画室",
    title: "她终于为自己买了一支笔",
    description:
      "二十年前放弃的画笔，在影楼后面的小房间里重新被拿起来。这一次，她画的是自己的窗户。",
    tag: "最新剧情",
  },
  {
    id: "hero-3",
    episodeId: "ep-16",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20film%20still%20of%20an%20old%20residential%20alley%20at%20sunset%2C%20long%20warm%20shadows%20on%20the%20ground%2C%20open%20fourth%20floor%20windows%20glowing%20orange%2C%20silhouette%20of%20a%20person%20with%20a%20suitcase%20walking%20away%2C%20bittersweet%20farewell%20atmosphere%2C%20cinematic%20grain%2C%20no%20text&width=1600&height=900&seq=fm4-hero-03&orientation=landscape",
    eyebrow: "大结局 · 第16集",
    title: "窗外的树，终于画完了",
    description:
      "志勋拖着行李箱走出巷口，回头看了一眼那栋旧楼。四楼的窗户是开着的。",
    tag: "大结局",
  },
];